/**
 * Dashboard company slug (URL) → values stored in `interviewquestions.company` (text[]).
 * Keep in sync when adding firms to mock interview.
 */
export const COMPANY_SLUG_TO_LABELS = {
  "jane-street": ["Jane Street"],
};

export function normalizeCompanySlug(raw) {
  return String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");
}

export function getCompanyLabelsForSlug(slug) {
  const key = normalizeCompanySlug(slug);
  const labels = COMPANY_SLUG_TO_LABELS[key];
  return Array.isArray(labels) ? labels.filter(Boolean) : null;
}

export function isMockInterviewCompanySlug(slug) {
  return getCompanyLabelsForSlug(slug) != null;
}

/**
 * Display name for UI/export — prefers explicit label, then company map, then title-cased slug.
 * @param {{ companyName?: string, companySlug?: string }} [options]
 */
export function resolveCompanyDisplayName(options = {}) {
  const explicit = String(options.companyName ?? "").trim();
  if (explicit) return explicit;

  const labels = getCompanyLabelsForSlug(options.companySlug);
  if (labels?.[0]) return labels[0];

  const slug = normalizeCompanySlug(options.companySlug);
  if (slug) {
    return slug
      .split("-")
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }

  return "Mock interview";
}
